/** Sector-specific experience labels shown under the ADVISOR product nav group. */
import { normalizeAppLanguage } from "util/locale";

const SECTOR_EXPERIENCE = {
  hospitality: { en: "Guest Experience", tr: "Misafir Deneyimi" },
  telecommunications: { en: "Subscriber Experience", tr: "Abone Deneyimi" },
  telecom: { en: "Subscriber Experience", tr: "Abone Deneyimi" },
  "network infrastructure": {
    en: "Network Experience",
    tr: "Ağ Deneyimi",
  },
  "financial services": { en: "Customer Experience", tr: "Müşteri Deneyimi" },
  banking: { en: "Customer Experience", tr: "Müşteri Deneyimi" },
  retail: { en: "Retail Experience", tr: "Perakende Deneyimi" },
  insurance: { en: "Insurance Experience", tr: "Sigorta Deneyimi" },
  healthcare: { en: "Patient Experience", tr: "Hasta Deneyimi" },
  airline: { en: "Passenger Experience", tr: "Yolcu Deneyimi" },
  automotive: { en: "Driver Experience", tr: "Sürücü Deneyimi" },
};

const normalizeIndustryKey = (name) =>
  String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const resolveLanguage = (language) =>
  normalizeAppLanguage(language) === "tr" ? "tr" : "en";

const matchSectorExperience = (industryName, language) => {
  const key = normalizeIndustryKey(industryName);
  if (!key || key === "others") {
    return null;
  }

  const lang = resolveLanguage(language);

  if (SECTOR_EXPERIENCE[key]) {
    return SECTOR_EXPERIENCE[key][lang];
  }

  for (const [pattern, labels] of Object.entries(SECTOR_EXPERIENCE)) {
    if (key.includes(pattern) || pattern.includes(key)) {
      return labels[lang];
    }
  }

  return null;
};

/** Nav item + panel title under ADVISOR (e.g. Misafir Deneyimi). */
export const resolveSectorExperienceLabel = (industryName, t, language) => {
  const matched = matchSectorExperience(industryName, language);
  if (matched) {
    return matched;
  }
  return t("nav.advisor_experience_default");
};

/** @deprecated use resolveSectorExperienceLabel */
export const resolveSectorAdvisorLabel = resolveSectorExperienceLabel;

/** Raw industry name for disclaimers and system prompts. */
export const resolveSectorDisplayName = (industryName, language) => {
  const key = normalizeIndustryKey(industryName);
  if (!key || key === "others") {
    return null;
  }
  return String(industryName).trim();
};
